export default function(){
	(function($) {

		// Open/close size chart
		function size_chart_modal_open(){
			// Add body class
			$('html').addClass('has-modal has-modal--size-chart');
		}

		function size_chart_modal_close(){
			$('html').removeClass('has-modal has-modal--size-chart');
		}

		function size_chart_modal_init(){
			$('[close-size-chart]').click(function(e){
				if($('html').hasClass('has-modal--size-chart')){
					size_chart_modal_close();
				}
			});
		}
		size_chart_modal_init();

		$('body').on('click', '[open-size-chart]', function(e){
			e.preventDefault();
			setTimeout( size_chart_modal_open , 0 );
		});

		$(document).keyup(function(e) {
			if (e.key === "Escape") { // escape key maps to keycode `27`
				if($('html').hasClass('has-modal--size-chart')){
					size_chart_modal_close();
				}
			}
		});

	})(jQuery);
}